export default __webpack_public_path__ + "static/media/bi_invert.9d274327.png";